import { mutations } from './mutations';
import { getters } from './getters';
import { actions } from './actions';
import { PatientState } from './state';

const defaultState: PatientState = {
  patients: [],
  patient_comments: [],
  minimalPatients: {},
};

export const patientModule = {
  state: defaultState,
  mutations,
  actions,
  getters,
};
